import Wujie from '@/components/wujie'

export default {
  routes: [

    // 驾驶舱
    {
      path: 'cockpit',
      name: 'cockpit',
      component: Wujie,
      props: { type: 'cockpit' },
      children: [
        {
          path: 'AgingStatistics',
          meta: { title: "账龄分析" },
        },
        {
          path: 'PaymentStatistics',
          meta: { title: "缴费总览" } },
        {
          // path: 'EnergyConsumptionStatistics',
          path: 'chartStatistics',
          meta: { title: "能耗管理" },
        },
        {
          path: 'pda',
          meta: { title: "到家巡检" } },
        {
          path: 'conversation',
          meta: { title: "舆情管理" },
        },
        {
          path: 'ReportRepairStatistics',
          meta: { title: "物业端" },
        },
        {
          path: 'ReportRepairOwnerStatistics',
          meta: { title: "业主端" },
        },
        {
          path: 'Group400Statistics',
          meta: { title: "品控中心" },
        },
        {
          path: 'ComplaintSuggestionsStatistics',
          meta: { title: "投诉建议" },
        },
        {
          path: 'VisitStatistics',
          meta: { title: "业主拜访" }
        },
        {
          path: 'SatisfactionStatistics',
          meta: { title: "满意度调查" }
        },
        {
          path: 'historyRate',
          meta: { title: "历年收缴" }
        },
        {
          // path: 'EnergyConsumptionStatistics',
          path: 'chart',
          meta: { title: "能耗管理" },
        },
        {
          path: 'badDebtSetting',
          meta: { title: "坏账拨备设置" }
        },
        {
          path: 'badDebt',
          meta: { title: "坏账拨备" }
        },
        {
          path: 'actualDebt',
          meta: { title: "实际拨备" }
        },
        {
          path: 'historyCollection',
          meta: { title: "龙虎榜" }
        },
        {
          path: 'planRate',
          meta: { title: "收缴通报" }
        },
        {
          path: 'parking',
          meta: { title: "智慧停车" }
        },
        {
          path: 'desktop',
          meta: { title: "人事总览" }
        },
      ]
    },

    // 协同办公
    {
      path: '/',
      name: 'CollaborativeOffice',
      component: Wujie,
      props: { type: 'office' },
      children: [
        {
          path: 'mail',
          children: [
            { path: 'list', meta: { title: "收件箱" } },
            { path: 'write', meta: { title: "写信" } },
            { path: 'draft', meta: { title: "草稿箱" } },
            { path: 'sent', meta: { title: "已发送" } },
            { path: 'trash', meta: { title: "已删除" } },
            { path: 'detail', meta: { title: "邮件详情" } },
          ],
        },
        {
          path: 'new',
          children: [
            {path: 'newList', meta: { title: "新闻列表" }},
            {path: 'detail', meta: { title: "新闻详情" }},
            {path: 'create', meta: { title: "新建新闻" }},
            {path: 'newManageList', meta: { title: "新闻管理" }},
          ],
        },
        {
          path: 'notice',
          children: [
            {path: 'receiveList', meta: { title: "我的收文" }},
            {path: 'create', meta: { title: "创建公文" }},
            {path: 'detail', meta: { title: "收文详情" }},
          ],
        },
        {
          path: 'notice',
          children: [
            {path: 'sendList', meta: { title: "我的发文" }},
            {path: 'detail', meta: { title: "发文详情" }},
          ],
        },
      ],
      meta: {
        title: "协同办公"
      }
    },

    // PDA
    {
      path: 'pda',
      name: 'pda',
      component: Wujie,
      props: { type: 'pda' },
      children: [
        { path: 'home', meta: { title: "巡检概况" } },
        { path: 'bluetooth', meta: { title: "蓝牙管理" } },
        { path: 'equipment', meta: { title: "任务管理" } },
        { path: 'check', meta: { title: "任务抽检" } },
        { path: 'inspection', meta: { title: "巡检管理" } },
        { path: 'diary', meta: { title: "操作日记" } },
        { path: 'jurisdiction', meta: { title: "权限架构" } },
        { path: 'department', meta: { title: "部门管理" } },
        { path: 'user', meta: { title: "人员管理" } },
        { path: 'repair', meta: { title: "整改工单" } },
        { path: 'map', meta: { title: "地图巡航" } },
        { path: 'deviceIndex', meta: { title: "工牌设备" } },
        { path: 'deviceUserIndex', meta: { title: "工牌管理" } },
      ],
    },

    // PDA NEW
    {
      path: 'quality-pda',
      component: Wujie,
      props: { type: 'quality' },
      children: [
        { path: 'third-overview', meta: { title: "非主营概况" } },
      ]
    },

    // 智慧校园
    {
      path: 'school',
      component: Wujie,
      props: { type: 'school' },
      children: [
        { path: 'goodslist', meta: { title: "学生缴费" } },
        { path: 'getStatement', meta: { title: "月统计" } },
        { path: 'chartStatistics', meta: { title: "缴费统计" } },
      ]
    },

    //能耗管理
    {
      path: 'secp',
      component: Wujie,
      props: { type: 'secp' },
      children: [
        // { path: 'memberHouse', meta: { title: "住户管理" } },
        // { path: 'energyRegion', meta: { title: "用能分区" } },
        { path: 'settlementPlan', meta: { title: "结算方案" } },
        { path: 'meterNoteDetail', meta: { title: "用能抄表" } },
        { path: 'order', meta: { title: "账单查询" } },
        { path: 'type', meta: { title: "资产管理" } },
        { path: 'useType', meta: { title: "用能类型管理" } },
        { path: 'use', meta: { title: "用能用途" } },
        { path: 'chartStatistics', meta: { title: "能耗管理" } },
        { path: 'useWarn', meta: { title: "用能预警" } },
        { path: 'chartUseWarn', meta: { title: "预警分析" } },
      ]
    },
    // 耗能管理页面
    {
      path: 'stat',
      component: Wujie,
      props: { type: 'secp' },
      children: [
        { path: 'chart', meta: { title: "能耗管理" } },
        { path: 'publicShareMeter', meta: { title: "公摊能耗分析" } },
        { path: 'meterInformation', meta: { title: "数据完整分析" } },
      ]
    },
    // 品质管理 - AI监控
    {
      path: 'camera',
      component: Wujie,
      props: { type: 'quality' },
      children: [
        { path: 'device', meta: { title: "设备管理" } },
      ]
    },

    // 满意度明细
    {
      path: 'question',
      component: Wujie,
      props: { type: 'quality' },
      children: [
        { path: 'question_answer', meta: { title: "满意度明细" } },
        { path: 'question_house', meta: { title: "参与调查房产" } },
        { path: 'question_sms', meta: { title: "短信推送记录" } },
      ]
    },

    // 品质管理 - 企业微信管理
    {
      path: 'wework',
      component: Wujie,
      props: { type: 'quality' },
      children: [
        { path: 'member', meta: { title: "员工管理" } },
        { path: 'group', meta: { title: "客户群管理" } },
      ]
    },

    // 业主拜访
    {
      path: 'visit',
      component: Wujie,
      props: { type: 'quality' },
      children: [
        { path: 'log', meta: { title: "业主拜访" } },
      ]
    },

    // 品质检查
    {
      path: 'quality-check',
      component: Wujie,
      props: { type: 'quality' },
      children: [
        { path: 'category', meta: { title: "检查分类" } },
        { path: 'template', meta: { title: "检查模板" } },
        { path: 'schedule', meta: { title: "年度计划" } },
        { path: 'record', meta: { title: "检查记录" } },
        { path: 'record-list', meta: { title: "检查记录" } },
        { path: 'repair', meta: { title: "整改记录" } },
        { path: 'report', meta: { title: "检查报告 " } },
        { path: 'reports', meta: { title: "检查报表" } },
      ]
    },

    // 客户分类
    {
      path: 'client',
      component: Wujie,
      props: { type: 'quality' },
      children: [
        { path: 'client_type', meta: { title: "客户分类" } },
      ]
    },
    // 客户信息
    {
      path: 'client',
      component: Wujie,
      props: { type: 'quality' },
      children: [
        { path: 'client_customer', meta: { title: "客户业主信息" } },
      ]
    },
    // 客户信息
    {
      path: 'client',
      component: Wujie,
      props: { type: 'quality' },
      children: [
        { path: 'client_list', meta: { title: "客户信息" } },
      ]
    },
    // 计划拜访
    {
      path: 'client',
      component: Wujie,
      props: { type: 'quality' },
      children: [
        { path: 'visit_plan', meta: { title: "计划拜访" } },
        { path: 'visit_project', meta: { title: "计划方案" } },
        { path: 'visit_gags', meta: { title: "计划花絮" } },
        { path: 'visit_report', meta: { title: "计划总结" } },
      ]
    },

    // 人力资源 - 排班
    {
      path: 'workclass',
      component: Wujie,
      props: { type: 'hr' },
      children: [
        { path: 'class', meta: { title: "班次设置" } },
        { path: 'class-edit', meta: { title: "编辑班次" } },
        { path: 'user', meta: { title: "排班管理" } },
        { path: 'check', meta: { title: "排班审核" } },
        { path: 'schedule', meta: { title: "排班计划表" } },
      ]
    },

    // 人力资源 - 薪酬管理
    {
      path: 'hr-salary',
      component: Wujie,
      props: { type: 'hr' },
      children: [
        { path: 'basic-setting', meta: { title: "基数设置" } },
        { path: 'salary-well-user-import', meta: { title: "基数设置导入" } },
        { path: 'salary-setting', meta: { title: "薪酬设置" } },
        { path: 'salary-setting-edit', meta: { title: "新增薪酬" } },
        { path: 'salary-account-set', meta: { title: "工资账套" } },
        { path: 'salary-staff', meta: { title: "绑定员工" } },
        { path: 'early-warning-department', meta: { title: "预警部门" } },
        { path: 'calculation-account-set', meta: { title: "算薪账套" } },
        { path: 'reporting-management', meta: { title: "填报管理" } },
        { path: 'reporting-setting', meta: { title: "填报项设置" } },
        { path: 'reporting-detail', meta: { title: "明细台账" } },
        { path: 'reporting-import', meta: { title: "添加补发代扣审批" } },
        { path: 'reporting-report', meta: { title: "审批明细台账" } },
        { path: 'salary-management-list', meta: { title: "薪酬管理" } },
        { path: 'salary-management-details', meta: { title: "发放工资表" } },
        { path: 'salary-management-report', meta: { title: "审批工资列表" } },
        { path: 'month-check', meta: { title: "月度检查" } },
        { path: 'salary-details', meta: { title: "薪酬明细" } },
        { path: 'cardinal-change', meta: { title: "异动检查" } },
        { path: 'cardinal-change-details', meta: { title: "基数异动明细表" } },
        { path: 'personnel-change-details', meta: { title: "人员异动明细表" } },
        { path: 'salary-change-details', meta: { title: "薪酬异动明细表" } },
        { path: 'subsidy-management', meta: { title: "补贴管理" } },
        { path: 'salary', meta: { title: "薪资发放" } },
        { path: "reporting-result", meta: {title: "添加绩效考核审批"}}
      ]
    },

    // 人力资源 - 基础设置
    {
      path: 'hr-setting',
      component: Wujie,
      props: { type: 'hr' },
      children: [
        { path: 'post-setting', meta: { title: "岗位设置" } },
        { path: 'group', meta: { title: "族群管理" } },
        { path: 'post-manage', meta: { title: "岗位管理" } },
        { path: 'position', meta: { title: "职位管理" } },
        { path: 'social-insurance', meta: { title: "社保管理" } },
        { path: 'fund-manage', meta: { title: "公积金管理" } },
        { path: 'pay-relation-manage', meta: { title: "缴纳关系管理" } },
        { path: 'legal_unit', meta: { title: "法定单位" } },
        { path: 'company', meta: { title: "劳务公司" } },
        { path: 'rank-setting', meta: { title: "职级设置" } },
      ]
    },

    // 人力资源 - 考勤管理
    {
      path: 'workcheck',
      component: Wujie,
      props: { type: 'hr' },
      children: [
        { path: 'app-list', meta: { title: "考勤机管理" } },
        { path: 'installation-method', meta: { title: "考勤机管理-员工策略" } },
        { path: 'installation-user', meta: { title: "考勤机管理-员工列表" } },
        { path: 'sync-center', meta: { title: "考勤机管理-同步中心" } },
        { path: 'set-list', meta: { title: "考勤设置" } },
        { path: 'department', meta: { title: "考勤部门" } },
        { path: 'work_check_record', meta: { title: "考勤记录" } },
        { path: 'work_check_maintenance', meta: { title: "考勤维护" } },
        { path: 'work_check_examine', meta: { title: "考勤审核" } },
        { path: 'work_check_annual', meta: { title: "年休假" } },
        { path: 'work_check_year', meta: { title: "调休假" } },
        { path: 'eWorkCheck', meta: { title: "考勤点设置" } },
        { path: 'eUserList', meta: { title: "员工列表" } },
        { path: 'eWorkCheckRecord', meta: { title: "考勤记录" } },
      ]
    },
    {
      path: 'attendance',
      component: Wujie,
      props: { type: 'hr' },
      children: [
        { path: 'machine', meta: { title: "新考勤机管理" } },
      ]
    },
    // 400投诉
    {
      path: 'complaint400',
      component: Wujie,
      props: { type: 'quality' },
      children: [
        { path: 'add', meta: { title: "话务处理" } },
      ]
    },
    // 400投诉历史列表
    {
      path: 'complaint400',
      component: Wujie,
      props: { type: 'quality' },
      children: [
        { path: 'list', meta: { title: "历史记录" } },
      ]
    },

    //员工信息
    {
      path: 'hr-staff',
      component: Wujie,
      props: { type: 'hr' },
      children: [
        { path: 'index', meta: { title: "员工信息" } },
        { path: 'userAdd', meta: { title: "新建员工" }},
        { path: 'UserBasicEditor', meta: { title: "基本信息" }},
        { path: 'UserPersonalEditor', meta: { title: "个人信息" }},
        { path: 'UserSalaryEditor', meta: { title: "薪资信息" }},
        { path: 'UserEducationalEditor', meta: { title: "教育经历" }},
        { path: 'UserWorkEditor', meta: { title: "工作经历" }},
        { path: 'UserTrainingEditor', meta: { title: "培训经历" }},
        { path: 'UserQualificationEditor', meta: { title: "资格证书" }},
        { path: 'UserFamilyEditor', meta: { title: "家庭信息" }},
        { path: 'UserContract', meta: { title: "员工合同" }},
        { path: 'roster', meta: { title: "花名册" } },
        { path: 'black-list', meta: { title: "黑名单管理" } },
        { path: 'level-list', meta: { title: "薪酬级别管理" } },
        { path: 'join-standards-list', meta: { title: "入职标准" } },
        { path: 'dept-hange-list', meta: { title: "员工变动明细" } },
      ]
    },
    //人事管理
    {
      path: 'hr-setup',
      component: Wujie,
      props: { type: 'hr' },
      children: [
        { path: 'company', meta: { title: "公司管理" } },
        { path: 'company-edit', meta: { title: "公司设置" } },
        { path: 'department', meta: { title: "部门管理" } },
        { path: 'department-edit', meta: { title: "部门设置" } },
        { path: 'business', meta: { title: "部门定编" } },
        { path: 'business-all', meta: { title: "批量定编人数查询" } },
        { path: 'business-edit', meta: { title: "批量定编人数设置" } },
        { path: 'business-import', meta: { title: "批量定编人数导入" } },
        { path: 'department-setting', meta: { title: "部门设置" } },
        { path: 'department-setting-detail', meta: { title: "部门编辑" } },
      ]
    },
    // 奖惩管理
    {
      path: 'punishments',
      component: Wujie,
      props: { type: 'hr' },
      children: [
        { path: 'type', meta: {title: "奖惩种类设置"} },
        { path: 'list', meta: {title: "奖惩管理"} },
      ]
    },

    //预算管理
    {
      path: 'budget',
      component: Wujie,
      props: { type: 'budget' },
      children: [
        { path: 'account-list', meta: { title: "科目代码" } },
        { path: 'plan-task', meta: { title: "预算计划预览" } },
        { path: 'budget-plan', meta: { title: "预算计划" } },
        { path: 'plan-detail', meta: { title: "预算计划详情" } },
        { path: 'adjust-apply', meta: { title: "预算调整" } },
        { path: 'expense-apply', meta: { title: "费用报销" } },
        { path: 'budget-apply', meta: { title: "月度资金计划" } },
        { path: 'expense-apply-summary', meta: { title: "费用报销统计表" } },
        { path: 'budget-apply-summary', meta: { title: "费用申请汇总表" } },
        { path: 'budget-year' , meta : {title : '收缴年度计划'}},
      ]
    },

    // 采购管理
    {
      path: 'procure',
      component: Wujie,
      props: { type: 'budget' },
      children: [
        { path: 'product-list', meta: { title: "物料管理" } },
        { path: 'storagelog-list', meta: { title: "出入库记录" } },
        { path: 'warehouse-list', meta: { title: "仓库管理" } },
        { path: 'warehouse-product-list', meta: { title: "仓库物料列表" } },
        { path: 'warehouse-bind-list', meta: { title: "仓库绑定列表" } },
        { path: 'product-category-list', meta: { title: "物料分类" } },
        { path: 'supplier-list', meta: { title: "供应商列表" } },
        { path: 'supplier-products-list', meta: { title: "供应商-商品" } },
        { path: 'supplier-products-region', meta: { title: "供应商-商品区域价格" } },
        { path: 'engineeringQuotation', meta: { title: "报价单" } },
        { path: 'engineeringQuotationAdd', meta: { title: "报价单-信息" } },
        { path: 'SaleQuotation', meta: { title: "销售价目表" } },
        { path: 'SaleQuotationAdd', meta: { title: "销售价目表-信息" } },
        { path: 'storehouse-in', meta: { title: "申购入库单" } },
        { path: 'storehouse-in-direct', meta: { title: "物料入库单" } },
        { path: 'storehouse-in-approval', meta: { title: "入库单审核" } },
        { path: 'storehouse-out', meta: { title: "物料出库单" } },
        { path: 'storehouse-out-approval', meta: { title: "出库单审核" } },
        { path: 'materialRequisition-list', meta: { title: "物料申购" } },
        { path: 'materialRequisition-examine', meta: { title: "申购单审核" } },
        { path: 'MaterialApplyBuyBillReport', meta: { title: "采购单明细表" } },
      ]
    },

    // 在线学习
    {
      path: 'study',
      component: Wujie,
      props: { type: 'hr' },
      children: [
        { path: 'index', meta: { title: "首页" } },
        { path: 'questionType', meta: { title: "题库分类" } },
        { path: 'questionBank', meta: { title: "题库管理" } },
        { path: 'testPaper', meta: { title: "试卷管理" } },
        { path: 'infoTestPaper', meta: { title: "试卷查看" } },
        { path: 'required-course', meta: { title: "我的必修课" } },
        { path: 'required-course-offline', meta: { title: "我的线下课" } },
        { path: 'required-course-info', meta: { title: "我的必修课-详情" } },
        { path: 'required-course-info-offline', meta: { title: "我的线下课-详情" } },
        { path: 'elective-courses', meta: { title: "我的选修课" } },
        { path: 'courseware-information', meta: { title: "课件信息" } },
        { path: 'requiredCourse-manage', meta: { title: "必修课管理" } },
        { path: 'requiredCourse-manage-offline', meta: { title: "线下课管理" } },
        { path: 'requiredCourse-courseware-information', meta: { title: "必修课管理-信息" } },
        { path: 'requiredCourse-courseware-information-offline', meta: { title: "必修课管理-信息" } },
        { path: 'student-manage', meta: { title: "必修课管理-学员" } },
        { path: 'student-manage-offline', meta: { title: "必修课管理-学员" } },
        { path: 'learning', meta: { title: "学习" } },
        { path: 'examination', meta: { title: "考试" } },
        { path: 'correct-list', meta: { title: "试卷批改" } },
        { path: 'myExam-list', meta: { title: "我的考试" } },
        { path: 'registration-review', meta: { title: "报名审核" } },
        { path: 'Exam-list', meta: { title: "成绩查询" } },
        { path: 'exam-correct', meta: { title: "评卷" } },
        { path: 'course-category-list', meta: { title: "课程分类" } },
        { path: 'lesson-list', meta: { title: "课程管理" } },
        { path: 'student-list', meta: { title: "学员管理" } },
      ]
    },
    // 业务拓展
    {
      path: 'zhoaocf',
      component: Wujie,
      props: { type: 'hr' },
      children: [
        { path: 'ledger-list', meta: { title: "价值信息" } },
        { path: 'type-list', meta: { title: "项目业态" } },
        { path: 'category-list', meta: { title: "项目分类" } },
        { path: 'region-list', meta: { title: "拓展单位" } },
        { path: 'process-list', meta: { title: "项目流程" } },
        { path: 'process-type', meta: { title: "职责类别" } }
      ]
    },
    // 培训认证
    {
      path: 'study',
      component: Wujie,
      props: { type: 'hr' },
      children: [
        { path: 'train-plan', meta: { title: "培训计划" } },
        { path: 'train-plan-pass', meta: { title: "计划审核" } },
        { path: 'train-application', meta: { title: "报名管理" } },
        { path: 'train-train', meta: { title: "培训管理" } },
        { path: 'red-envelopes', meta: { title: "红包管理" } },
      ]
    },

    // 人事报表{ path: 'personnelReport', meta: { title: "人事报表" } },
    {
      path: 'personnelReport',
      component: Wujie,
      props: { type: 'hr' },
      children: [
        { path: 'index', meta: { title: "人事报表" } },
        { path: 'user-report', meta: { title: "人力资源统计分析" } },
      ]
    },

    // 企业微信
    {
      path: 'user-group',
      component: Wujie,
      props: { type: 'quality' },
      children: [
        { path: 'list', meta: { title: "内部群管理" } },
        { path: 'send', meta: { title: "消息推送" } },
        { path: 'log', meta: { title: "消息管理" } },
      ]
    },

    // 维保系统
    {
      path: 'maintenance',
      component: Wujie,
      props: { type: 'school' },
      children: [
        { path: 'index', meta: { title: "维保统计" } },

        // 维保排期
        { path: 'plan', meta: { title: "保养计划" } },
        { path: 'schedule', meta: { title: "保养排期" } },
        { path: 'elevator-list', meta: { title: "电梯管理" } },
        { path: 'customer-list', meta: { title: "使用单位" } },
        { path: 'project-list', meta: { title: "项目管理" } },
        { path: 'elevator-check', meta: { title: "电梯信息审核" } },

        // 维保工单
        { path: 'work-order', meta: { title: "保养单" } },
        { path: 'urgent-order', meta: { title: "急修单" } },
        { path: 'repair-order', meta: { title: "大修单" } },
        { path: 'rescue-order', meta: { title: "救援单" } },
        { path: 'order-check', meta: { title: "工单审核" } },
        { path: 'work-comment', meta: { title: "评分表" } },

        // 维保人员
        { path: 'user-group', meta: { title: "班组管理" } },
        { path: 'user-certificate', meta: { title: "证件管理" } },

        // 维保设置
        { path: 'config', meta: { title: "维保参数" } },
        { path: 'template', meta: { title: "维保项" } },

        // 销售合同
        { path: 'contract-manage', meta: { title: "合同管理" } },
        // { path: 'contract-review', meta: { title: "合同审核" } },
        // { path: 'contract-params', meta: { title: "销售参数" } },
      ]
    },
    // 消防维保
    {
      path: 'fireproof',
      component: Wujie,
      props: { type: 'school' },
      children: [
        { path: 'index', meta: { title: "维保统计" } },
        // 维保排期
        { path: 'schedule', meta: { title: "维保计划" } },
        { path: 'schedule-detail', meta: { title: "计划明细" } },
        { path: 'plan-detail', meta: { title: "计划详情" } },
        { path: 'report', meta: { title: "线下报告" } },
        { path: 'project', meta: { title: "项目管理" } },
        // { path: 'customer', meta: { title: "使用单位" } },
        // { path: 'project', meta: { title: "项目管理" } },
        // { path: 'elevator-check', meta: { title: "器材信息审核" } },
        // 维保工单
        // { path: 'work-order', meta: { title: "保养单" } },
        // { path: 'urgent-order', meta: { title: "急修单" } },
        // { path: 'repair-order', meta: { title: "大修单" } },
        // { path: 'rescue-order', meta: { title: "救援单" } },
        // { path: 'order-check', meta: { title: "工单审核" } },
        // 维保人员
        { path: 'worker', meta: { title: "班组管理" } },
        // { path: 'user-certificate', meta: { title: "证件管理" } },
        // 维保设置
        { path: 'template', meta: { title: "维保项" } },
        // 合同管理
        { path: 'contract-manage', meta: { title: "合同管理" } },
      ]
    },
    // 智能维保
    {
      path: 'intellect',
      component: Wujie,
      props: { type: 'school' },
      children: [
        { path: 'index', meta: { title: "维保统计" } },
        // 维保排期
        { path: 'plan', meta: { title: "保养计划" } },
        { path: 'schedule', meta: { title: "保养排期" } },
        { path: 'equipment', meta: { title: "产品管理" } },
        { path: 'customer', meta: { title: "使用单位" } },
        { path: 'project', meta: { title: "项目管理" } },
        { path: 'elevator-check', meta: { title: "产品信息审核" } },
        // 维保工单
        { path: 'work-order', meta: { title: "保养单" } },
        { path: 'urgent-order', meta: { title: "急修单" } },
        { path: 'repair-order', meta: { title: "大修单" } },
        { path: 'rescue-order', meta: { title: "救援单" } },
        { path: 'order-check', meta: { title: "工单审核" } },
        // 维保人员
        { path: 'user-group', meta: { title: "班组管理" } },
        { path: 'user-certificate', meta: { title: "证件管理" } },
        // 维保设置
        { path: 'config', meta: { title: "维保参数" } },
        { path: 'template', meta: { title: "维保项" } },
        // 销售合同
        { path: 'contract-manage', meta: { title: "合同管理" } },
      ]
    },
    // 智慧停车
    {
      path: 'park',
      component: Wujie,
      props: { type: 'school' },
      children: [
        { path: 'index', meta: { title: "停车场列表" } },
        { path: 'income', meta: { title: "支付汇总表" } },
      ]
    },

    // 工程维保
    {
      path: 'device-maintenance',
      component: Wujie,
      props: { type: 'school' },
      children: [
        { path: 'project', meta: { title: "项目管理" } },
        // { path: 'user', meta: { title: "人员管理" } },
        { path: 'desc', meta: { title: "维保标准" } },
        { path: 'category', meta: { title: "设备分类" } },
        { path: 'device', meta: { title: "设备管理" } },
        { path: 'schedule', meta: { title: "计划管理" } },
        { path: 'record', meta: { title: "维保记录" } },
        { path: 'repair', meta: { title: "整改记录" } },
        { path: 'check-template', meta: { title: "抽检模板" } },
        { path: 'check-record', meta: { title: "抽检记录" } },
        { path: 'fix', meta: { title: "设备维修" } },
      ]
    },
    // 合同管理
    {
      path: 'contract',
      component: Wujie,
      props: { type: 'budget' },
      children: [
        { path: 'cust-list', meta: { title: "客户列表" } },
        { path: 'contract-list', meta: { title: "合同列表" } },
        { path: 'cate-list', meta: { title: "分类列表" } },
        { path: 'field-list', meta: { title: "字典列表" } },
        { path: 'template-list', meta: { title: "合同列表" } },
        { path: 'business-list', meta: { title: "业户类型列表" } },
      ]
    },

    // 预算编辑
    {
      path: 'center',
      component: Wujie,
      props: { type: 'budget' },
      children : [
        { path : 'index1' , meta : {title : '项目预算模板'}},
        { path : 'index2' , meta : {title : '职能预算模板'}},
        { path : 'index3' , meta : {title : '市场预算模板'}},
        { path : 'report1' , meta : {title : '项目预算汇总'}},
        { path : 'report2' , meta : {title : '职能预算汇总'}},
        { path : 'report3' , meta : {title : '市场预算汇总'}},
        { path : 'report-multi' , meta : {title : '分项目汇总'}},
        { path : 'permission' , meta : {title : '权限管理'}},
        { path : 'base' , meta : {title : '基础数据导入'}},
        { path : 'data-report' , meta : {title : '基础数据管理'}},
        { path : 'authorized-rule' , meta : {title : '定编数据'}},
        { path : 'authorized-administration' , meta : {title : '项目基础数据'}},
        { path : 'facility-list' , meta : {title : '设施设备账单'}},
        { path : 'discount' , meta : {title : '折扣管理'}},
        { path : 'document' , meta : {title : '档案管理'}},
        { path : 'schedule' , meta : {title : '预算部门管理'}},
      ]
    },

    // 合同管理
    {
      path: 'agreement',
      component: Wujie,
      props: { type: 'agreement' },
      children: [
        { path: 'cust-list', meta: { title: "客户列表" } },
        { path: 'index', meta: { title: "合同列表" } },
        { path: 'detail', meta: { title: "合同详情" } },
        { path: 'category', meta: { title: "分类列表" } },
        // { path: 'organize-list', meta: { title: "组织架构列表" } },
        // { path: 'business-list', meta: { title: "业户类型列表" } },
        // { path: 'project-list', meta: { title: "项目列表" } },
        { path: 'payment-list', meta: { title: "合同支付" } },
        { path: 'payment/payable-plan', meta: { title: "应付计划" } },
        { path: 'change', meta: { title: "合同变更" } },
        { path: 'change-comparison', meta: { title: "变更内容对比" } },
        { path: 'paylog-list', meta: { title: "计提列表" } },
        { path: 'accrue-list', meta: { title: "计提列表" } },
        { path: 'payment-change-record', meta: { title: "合同账款变动记录" } },
        { path: 'payment-invoice', meta: { title: '开票管理' } },
        { path: 'report/cost-ledger', meta: { title: '成本类合同台账' } },
        { path: 'report/accrual-expense-ledger', meta: { title: '权责支出台账' } },
        { path: 'report/paid-ledger', meta: { title: '已付款台账' } },
        { path: 'report/payable-ledger', meta: { title: '应付台账' } },
        { path: 'report/unpaid-ledger', meta: {title: '欠费账龄表'} },
        { path: 'report/salary-advance-payment-ledger', meta: { title: '劳务预付款台账' } },
        { path: 'report/salary-statement-ledger', meta: {title: '劳务结算单台账' } },
        { path: 'archive/list', meta: { title: '归档列表' } },
        { path: 'archive/category', meta: { title: '归档分类' } },
        { path: 'add', meta: { title: '合同创建' } },
        { path: 'accrual', meta: { title: '计提列表' } },
        { path: 'payment-behalf', meta: { title: '代付单' } },
        { path: 'collection-behalf', meta: { title: '代收单' } },
        { path: 'deposit', meta: { title: '保证金' } },
        { path: 'deposit/refund', meta: { title: '保证金退付' } },
        { path: 'deposit/log', meta: { title: '保证金流水' } }
      ]
    },

  ]
}



// WEBPACK FOOTER //
// ./src/router/wujie.js